import { z } from 'zod';
import { PromotionCreditType } from '../../constants/promotion-credit-type.js';
import { optionalTrimmedNullableString, requireAtLeastOneField } from '../zod-helpers/index.js';
import { PROMOTION_CREDIT_CONSTRAINTS } from './constraints.js';
import { creditAmountInput } from './credit-amount-input.js';
import { creditDateInput } from './credit-date-input.js';
import { promotionCreditLineUpdateInputSchema } from './line-update-input.js';
import { promotionCreditLinesMessage } from './lines-message.js';
import { OVERPAYMENT_NOT_CHANGEABLE_MESSAGE } from './overpayment-not-changeable-message.js';
import { promotionLinkInput } from './promotion-link-input.js';
import { refineExpirationAfterIssued } from './refine-credit-dates.js';
import { refineCreditLines } from './refine-credit-lines.js';
// The lock on `amount` and `lines` once any of a credit is used is enforced server-side under the row lock.
export const updatePromotionCreditInputSchema = requireAtLeastOneField(z.object({
    promotionCreditTypeId: z
        .enum(PromotionCreditType, 'Invalid credit type selection.')
        .refine((type) => type !== PromotionCreditType.OVERPAYMENT, {
        message: OVERPAYMENT_NOT_CHANGEABLE_MESSAGE,
    })
        .optional(),
    amount: creditAmountInput.optional(),
    dateApplicable: creditDateInput('Issued date').optional(),
    expirationDate: creditDateInput('Expiration date').optional(),
    details: optionalTrimmedNullableString(PROMOTION_CREDIT_CONSTRAINTS.details.maxLength),
    notes: optionalTrimmedNullableString(PROMOTION_CREDIT_CONSTRAINTS.notes.maxLength),
    promotionId: promotionLinkInput,
    lines: z
        .array(promotionCreditLineUpdateInputSchema)
        .max(PROMOTION_CREDIT_CONSTRAINTS.lines.max, promotionCreditLinesMessage)
        .nullish()
        .transform((lines) => lines ?? undefined),
})).superRefine((value, context) => {
    refineExpirationAfterIssued(value, context);
    refineCreditLines(value, context);
});
//# sourceMappingURL=update-input.js.map